/** 与后端 user_fields 一致：手机 11 位数字、工号 6 位数字、姓名 2～20 汉字（可含·） */

export const phoneRules = [
  { required: true, message: '请输入手机号' },
  { pattern: /^\d{11}$/, message: '手机号须为11位数字' },
];

export const workNoRules = [
  { required: true, message: '请输入工号' },
  { pattern: /^\d{6}$/, message: '工号须为6位数字' },
];

export const chineseNameRules = [
  { required: true, message: '请输入姓名' },
  {
    pattern: /^[\u4e00-\u9fff\u00b7·]{2,20}$/,
    message: '姓名须为2～20个汉字（可含间隔号·）',
  },
];
